export default [
  { key: "white", text: "White Flies", value: "white" },
  { key: "house", text: "House Flies", value: "house" }
];
